(function(){
  function qsParams() {
    const params = {};
    const search = window.location.search.replace(/^\?/, '');
    if (!search) return params;
    search.split('&').forEach(function(part){
      const pair = part.split('=');
      try {
        const key = decodeURIComponent(pair[0] || '');
        const val = decodeURIComponent(pair[1] || '');
        if (key) params[key] = val;
      } catch (e) {
        // ignore malformed
      }
    });
    return params;
  }

  function makeSectionHandlers(section) {
    const input = section.querySelector('#dt-input');
    const btn = section.querySelector('#dt-button');
    const resultsDiv = section.querySelector('#dt-results');
    const errorDiv = section.querySelector('#dt-error');

    if (!input || !btn || !resultsDiv || !errorDiv) return;

    function showError(msg) {
      errorDiv.style.display = 'block';
      errorDiv.innerHTML = '<div class="dt-error-message">' + msg + '</div>';
    }

    function showResults(orderId, data) {
      resultsDiv.style.display = 'block';

      let guides = [];
      if (Array.isArray(data) && data.length > 0) {
        if (data[0].eventos) {
          guides = data;
        } else {
          guides = [{ guiaId: data[0].uesId || 'N/A', eventos: data }];
        }
      } else {
        resultsDiv.innerHTML = '<div class="dt-error-message">No se encontraron resultados.</div>';
        return;
      }

      let html = '';
      guides.forEach(function(guide){
        const guideId = guide.guiaId;
        const events = guide.eventos || [];
        const pickupEvent = events.find(function(e){ return e && e.pickup && e.pickup.trim() !== ''; });
        let deliveryTypeHtml = 'Envio a domicilio <strong>Interior</strong>';
        if (pickupEvent) deliveryTypeHtml = 'Retiro en punto <strong>' + (pickupEvent.pickup || '') + '</strong>';

        if (customApiUrl) {
          html += '\n            <div class="dt-result-card">\n              <div>\n                 <div class="dt-order-info">Seguimiento: N\u00B0 ' + escapeHtml(orderId) + '</div>\n              </div>\n            </div>\n         ';
        } else {
          html += '\n            <div class="dt-result-card">\n              <div>\n                 <div class="dt-order-info">Pedido: N\u00B0 ' + escapeHtml(orderId) + '</div>\n              </div>\n              <div>\n                 <div class="dt-delivery-type">' + deliveryTypeHtml + '</div>\n              </div>\n              <div class="dt-guide-number">NUMERO DE GUIA: ' + escapeHtml(guideId) + '</div>\n            </div>\n         ';
        }

        html += '<div class="dt-timeline">';
        events.forEach(function(event){
          const descHtml = event && event.subestado ? '<div class="dt-desc">' + escapeHtml(event.subestado) + '</div>' : '';
          const estado = event && event.estado ? escapeHtml(event.estado) : '';
          const fecha = event && event.fecha ? escapeHtml(event.fecha) : '';
          html += '\n              <div class="dt-timeline-item">\n                <div class="dt-timeline-icon">\n                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>\n                </div>\n                <div class="dt-timeline-content">\n                  <div>\n                    <div class="dt-status">' + estado + '</div>\n                    ' + descHtml + '\n                  </div>\n                  <div class="dt-date">' + fecha + '</div>\n                </div>\n              </div>\n            ';
        });
        html += '</div>';
        html += '<div style="margin-bottom: 40px;"></div>';
      });

      resultsDiv.innerHTML = html;
    }

    function escapeHtml(str) {
      if (str == null) return '';
      return String(str).replace(/[&<>"'`]/g, function(s){
        return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":"&#39;","`":"&#96;"})[s];
      });
    }

    const customApiUrl = (section.getAttribute('data-api-url') || '').trim();
    const apiDomainOverride = (section.getAttribute('data-api-domain') || '').trim().replace(/\/+$/, '');

    async function searchMiddleware(query) {
      const url = new URL(customApiUrl, window.location.origin);
      url.searchParams.set('ref', query);
      const resp = await fetch(url.toString(), { headers: { Accept: 'application/json' } });
      if (resp.status === 404) {
        showError('No encontramos ning\u00FAn env\u00EDo con ese n\u00FAmero. Revis\u00E1 que est\u00E9 bien escrito e intent\u00E1 de nuevo.');
        return;
      }
      if (resp.status === 429) {
        showError('Demasiadas consultas. Esper\u00E1 un minuto.');
        return;
      }
      if (!resp.ok) throw new Error('HTTP status ' + resp.status);

      const json = await resp.json();
      // Accept both { fase, datos: {...} } and a bare datos object
      const datos = json && json.datos ? json.datos : json;
      if (!datos || (json.fase && json.fase !== 'ok')) {
        showError('No se encontraron resultados.');
        return;
      }

      const eventos = (Array.isArray(datos.eventos) ? datos.eventos : []).map(function(e){
        return {
          estado: e && e.titulo,
          subestado: e && [e.detalle, e.nota].filter(Boolean).join(' - '),
          fecha: e && (e.fechaLocal || e.fecha)
        };
      });
      showResults(query, [{ guiaId: 'N/A', eventos: eventos }]);
    }

    async function performSearch(query) {
      if (!query) return;
      resultsDiv.style.display = 'none';
      errorDiv.style.display = 'none';
      resultsDiv.innerHTML = '';
      errorDiv.innerHTML = '';

      const originalText = btn.textContent;
      btn.textContent = 'Cargando...';
      btn.disabled = true;

      try {
        if (customApiUrl) {
          await searchMiddleware(query);
          return;
        }
        const API_BASE = apiDomainOverride || window.themeVariables?.settings?.externalOrderApiDomain;
        const resp = await fetch(API_BASE + '/shopify/tracking/' + encodeURIComponent(query));
        if (!resp.ok) throw new Error('HTTP status ' + resp.status);
        const data = await resp.json();
        if (data && data.error) showError(data.error);
        else showResults(query, data);
      } catch (err) {
        console.error('API Error:', err);
        showError('Error al consultar  el servicio de rastreo. Por favor, intente nuevamente.');
      } finally {
        btn.textContent = originalText;
        btn.disabled = false;
      }
    }

    btn.addEventListener('click', function(){
      const q = input.value.trim();
      if (!q) return;
      performSearch(q);
    });

    // Param detection: only use the specific URL parameter matching input.name
    const params = qsParams();
    const paramKey = input.name || 'id';
    const found = params.hasOwnProperty(paramKey) ? params[paramKey] : null;
    if (found) {
      input.value = found;
      performSearch(found);
    }
  }

  // Find all sections and initialize
  function initAll() {
    const sections = document.querySelectorAll('.delivery-tracking-section');
    sections.forEach(function(sec){ makeSectionHandlers(sec); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
